import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, TemplateRef, inject } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ModalService } from '../../services/modal/modal.service';

@Component({
  selector: 'bodyanalytics-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  imports: [NgClass, NgTemplateOutlet],
})
export class ModalComponent implements OnInit, OnDestroy {
  private modalService = inject(ModalService);
  private el = inject(ElementRef);

  @Input() id!: string;
  @Input() title = '';
  @Input() body: TemplateRef<any> | null = null;
  @Input() footer: TemplateRef<any> | null = null;
  @Input() size: 'sm' | 'lg' | 'xl' | '' = '';
  isOpen = false;

  get sizeClass() {
    return {
      'modal-sm': this.size === 'sm',
      'modal-lg': this.size === 'lg',
      'modal-xl': this.size === 'xl',
    };
  }

  ngOnInit(): void {
    if (!this.id) {
      console.error('Modal must have an ID');
      return;
    }

    this.modalService.registerModal(this);

    document.body.appendChild(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    document.body.removeChild(this.el.nativeElement);
  }

  open(): void {
    this.isOpen = true;
    document.body.classList.add('modal-open');
  }

  close(): void {
    this.isOpen = false;
    document.body.classList.remove('modal-open');
  }

  /**
   * BUG-A6 — outside-click dismiss, Bootstrap's own pattern: the full-viewport
   * `.modal` layer sits above the backdrop and receives every click outside
   * the dialog, so dismiss when (and only when) the click target IS the
   * `.modal` element itself. Clicks inside `.modal-dialog` bubble up with a
   * different target and are ignored.
   */
  onModalClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  /** BUG-A6 — Escape dismisses the open modal (matches Bootstrap's default keyboard behavior). */
  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen) {
      this.close();
    }
  }
}
